import { render } from "./OutputArea.vue?vue&type=template&id=317cc710&scoped=true"
import script from "./OutputArea.vue?vue&type=script&lang=js"
export * from "./OutputArea.vue?vue&type=script&lang=js"

import "./OutputArea.vue?vue&type=style&index=0&id=317cc710&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317cc710"]])

export default __exports__